import React from "react";

export const Others = ({ setOtherValue, error, setError}) => {
    const { feedbackContent } = setOtherValue;
    return (
        <div className="p-md-10 p-5 bg-gray rounded">
            <h6 className="mb-5">Please let us know the issues so that we can try and resolve it to our best capabilities.</h6>
            <div className="alternative-form">
                <form>
                    <div className="form-group">
                        <textarea className="form-control" value={feedbackContent} placeholder="Enter your feedback" rows="6" onChange={(e) => {
                            setOtherValue(prevState => ({ ...prevState, feedbackContent: e.target.value }));
                            setError(false);
                        }
                    }/>
                    {error ? <span id="feedsfield2error" className="errorMessage required">This field is required</span> : null}
                    </div>
                </form>
            </div>
         </div>
    )
}

export default Others;